/**
 * Kody pól lokalizacji firmy — spójne z backendem
 * (config/locales.yml, Companies::Configuration::Locales).
 *
 * Etykiety w UI: i18next `common.<code>` (np. common.monday, common.metric).
 */
export const FIRST_DAY_OF_WEEK_CODES = ['monday', 'sunday'] as const;
export type FirstDayOfWeekCode = (typeof FIRST_DAY_OF_WEEK_CODES)[number];

export const MEASUREMENT_UNIT_CODES = ['metric', 'imperial'] as const;
export type MeasurementUnitCode = (typeof MEASUREMENT_UNIT_CODES)[number];
